import { Box, useColorModeValue } from '@chakra-ui/react';
import Editor, { useMonaco } from '@monaco-editor/react';
import monaco from 'monaco-editor';
import React, { useEffect } from 'react';

import {
  defaultTheme,
  lightTheme,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/edit/MonacoEditor/ui/common';

// Constants
const commonEditorOptions: monaco.editor.IEditorOptions = {
  fontSize: 16,
  minimap: {
    enabled: false,
  },
  automaticLayout: true,
};
const editorOptions: monaco.editor.IEditorOptions = {
  ...commonEditorOptions,
  quickSuggestions: {
    other: 'inline',
    comments: false,
    strings: true,
  },
  suggest: {
    snippetsPreventQuickSuggestions: false,
  },
};

const readOnlyEditorOptions: monaco.editor.IEditorOptions = {
  ...commonEditorOptions,
  domReadOnly: true,
  readOnly: true,
};

// Exports
type Props = {
  id: string;
  value: string;
  schema?: object;
  onChange: (
    value: string | undefined,
    ev: monaco.editor.IModelContentChangedEvent,
  ) => void;
  onValidate: (markers: monaco.editor.IMarker[]) => void;
  readOnly: boolean;
};
export const ArtifactEditor = ({
  id,
  schema,
  value,
  onChange,
  onValidate,
  readOnly,
}: Props) => {
  const monacoObj = useMonaco();
  const theme = useColorModeValue(lightTheme, defaultTheme);

  const readOnlyMode = readOnly || !schema;

  useEffect(() => {
    if (monacoObj) {
      monacoObj.languages.json.jsonDefaults.setDiagnosticsOptions(
        readOnlyMode
          ? { validate: false }
          : {
              validate: true,
              schemaValidation: 'warning',
              schemas: [
                {
                  uri: 'ArtifactSchema',
                  fileMatch: ['*'],
                  schema,
                },
              ],
            },
      );
    }
  }, [monacoObj, readOnlyMode, schema]);

  return (
    <Box width="100%" height="100%">
      <Editor
        path={id}
        defaultLanguage="json"
        value={value}
        theme={theme}
        options={readOnlyMode ? readOnlyEditorOptions : editorOptions}
        onChange={onChange}
        onValidate={(markers) => onValidate(markers)}
      />
    </Box>
  );
};
